var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingScreenSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 122,
    viewBox: "0 0 168 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.669 89.1264H25.0254C22.7253 89.1264 20.9442 87.2484 21.0622 84.95L24.6873 15.6458C24.8091 13.3475 26.7868 11.4695 29.0869 11.4695H130.731C133.031 11.4695 134.812 13.3475 134.694 15.6458L131.073 84.95C130.951 87.2484 128.973 89.1264 126.673 89.1264H126.669Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.343 89.1264H24.6992C22.3991 89.1264 20.6181 87.2484 20.736 84.95L24.3611 15.6458C24.483 13.3475 26.4606 11.4695 28.7607 11.4695H130.404C132.705 11.4695 134.486 13.3475 134.368 15.6458L130.747 84.95C130.625 87.2484 128.647 89.1264 126.347 89.1264H126.343Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.291 13.5596H28.6468C28.5328 13.5596 28.4188 13.5636 28.3047 13.5753C25.6783 13.7875 25.7216 17.7399 28.3401 17.7399H130.157C132.779 17.7399 133.232 13.7914 130.629 13.5753C130.515 13.5675 130.405 13.5596 130.287 13.5596H130.291Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0372 15.6458C31.0096 16.1762 30.5575 16.6045 30.0306 16.6045C29.5038 16.6045 29.0949 16.1762 29.1224 15.6458C29.1499 15.1154 29.6021 14.6872 30.1289 14.6872C30.6558 14.6872 31.0647 15.1154 31.0372 15.6458Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2969 15.6458C34.2694 16.1762 33.8173 16.6045 33.2904 16.6045C32.7636 16.6045 32.3546 16.1762 32.3822 15.6458C32.4097 15.1154 32.8618 14.6872 33.3887 14.6872C33.9156 14.6872 34.3245 15.1154 34.2969 15.6458Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5567 15.6458C37.5292 16.1762 37.077 16.6045 36.5502 16.6045C36.0233 16.6045 35.6144 16.1762 35.6419 15.6458C35.6695 15.1154 36.1216 14.6872 36.6485 14.6872C37.1753 14.6872 37.5842 15.1154 37.5567 15.6458Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.507 82.2117H27.2594C26.422 82.2117 25.7811 81.532 25.8243 80.6991L28.8007 23.7038C28.8439 22.867 29.5595 22.1912 30.397 22.1912H127.649C128.486 22.1912 129.127 22.8709 129.084 23.7038L126.108 80.6991C126.064 81.5359 125.349 82.2117 124.511 82.2117H124.507Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.266 37.38H60.5569C58.3945 37.38 56.5308 39.148 56.4168 41.3127L52.9293 108.059C52.8153 110.22 54.4942 111.992 56.6605 111.992H153.366C155.528 111.992 157.392 110.224 157.506 108.059L160.994 41.3127C161.108 39.1519 159.429 37.38 157.262 37.38H157.266Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.438 110.68C154.885 110.68 156.123 109.505 156.198 108.059L159.686 41.3128C159.76 39.867 158.648 38.6923 157.201 38.6923H60.4913C59.0445 38.6923 57.806 39.867 57.7313 41.3128L54.2438 108.059C54.1691 109.505 55.2818 110.68 56.7287 110.68H153.434H153.438Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M68.9986 89.7668H143.352C145.809 89.7668 147.925 87.7592 148.054 85.3036L149.596 55.7865C149.725 53.331 147.818 51.3234 145.361 51.3234H71.0077C68.5503 51.3234 66.4351 53.331 66.3053 55.7865L64.7641 85.3036C64.6343 87.7592 66.5412 89.7668 68.9986 89.7668Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M117.501 98.9366L116.888 110.68H93.2773L93.8907 98.9366C93.9969 96.8897 95.7465 95.2278 97.7949 95.2278H113.986C116.034 95.2278 117.611 96.8858 117.501 98.9366Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M87.663 98.9366L87.0497 110.68H63.4395L64.0528 98.9366C64.159 96.8897 65.9086 95.2278 67.957 95.2278H84.148C86.1965 95.2278 87.7731 96.8858 87.663 98.9366Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M147.339 98.9366L146.725 110.68H123.115L123.729 98.9366C123.835 96.8897 125.584 95.2278 127.633 95.2278H143.824C145.872 95.2278 147.449 96.8858 147.339 98.9366Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M139.085 68.2684H107.329C105.618 68.2684 104.23 69.6545 104.23 71.3643C104.23 73.0741 105.618 74.4602 107.329 74.4602H139.085C140.797 74.4602 142.184 73.0741 142.184 71.3643C142.184 69.6545 140.797 68.2684 139.085 68.2684Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M117.445 83.8697H138.425C140.132 83.8697 141.598 82.4749 141.685 80.7738C141.775 79.0687 140.45 77.6779 138.748 77.6779H117.768C116.061 77.6779 114.595 79.0726 114.508 80.7738C114.418 82.4789 115.743 83.8697 117.445 83.8697Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6492 45.3162H67.8001C67.2772 45.3162 66.8762 44.8919 66.9037 44.3694C66.9312 43.8469 67.3794 43.4225 67.9023 43.4225H74.7515C75.2744 43.4225 75.6754 43.8469 75.6479 44.3694C75.6204 44.8919 75.1722 45.3162 74.6492 45.3162Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7072 44.3694C78.6639 45.1944 79.2969 45.8623 80.1226 45.8623C80.9483 45.8623 81.6521 45.1944 81.6953 44.3694C81.7385 43.5443 81.1055 42.8764 80.2799 42.8764C79.4542 42.8764 78.7504 43.5443 78.7072 44.3694Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.281 45.8977H149.383C149.784 45.8977 150.13 45.5716 150.15 45.1708L150.232 43.5679C150.252 43.1672 149.941 42.8411 149.54 42.8411H146.438C146.037 42.8411 145.691 43.1672 145.671 43.5679L145.589 45.1708C145.569 45.5716 145.88 45.8977 146.281 45.8977Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.763 44.8448H141.422C141.682 44.8448 141.906 44.6326 141.922 44.3733C141.933 44.114 141.733 43.9019 141.473 43.9019H133.814C133.555 43.9019 133.331 44.114 133.315 44.3733C133.303 44.6326 133.504 44.8448 133.763 44.8448Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.482 44.8448H128.141C128.4 44.8448 128.625 44.6326 128.64 44.3733C128.652 44.114 128.452 43.9019 128.192 43.9019H120.533C120.274 43.9019 120.049 44.114 120.034 44.3733C120.022 44.6326 120.222 44.8448 120.482 44.8448Z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.197 44.8448H114.856C115.115 44.8448 115.339 44.6326 115.355 44.3733C115.367 44.114 115.166 43.9019 114.907 43.9019H107.248C106.988 43.9019 106.764 44.114 106.749 44.3733C106.737 44.6326 106.937 44.8448 107.197 44.8448Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9155 44.8448H101.575C101.834 44.8448 102.058 44.6326 102.074 44.3733C102.086 44.114 101.885 43.9019 101.626 43.9019H93.9666C93.7071 43.9019 93.483 44.114 93.4673 44.3733C93.4555 44.6326 93.656 44.8448 93.9155 44.8448Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1459_1465)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 61,
    r: 27,
    fill: "#27A376"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54L79.875 70L73 62.7273",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1459_1465",
    x: 51,
    y: 28,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1459_1465"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1459_1465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1459_1465",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingScreenSuccess);
export default __webpack_public_path__ + "static/media/waiting-screen-success.886e6d03dfd755bf053d0d6057476364.svg";
export { ForwardRef as ReactComponent };